export default __webpack_public_path__ + "static/media/progreso.a368abe2.png";